import { PurchaseOrderImportReportRow } from "../../types/purchase-order.type";
import { downloadBlob } from "../Gb1SaleReport/utils";

/**
 * รายงาน "แถวที่อ่านไม่ได้" เป็นไฟล์ CSV ให้เปิดคู่กับไฟล์ต้นฉบับได้
 *
 * ตัวช่วย escape ของ PathwayUpload/reportCsv.ts ไม่ได้ export ออกมา และ API ที่
 * export ผูกกับ PathwayUploadReportRow (มีคอลัมน์ สาย/วัน ซึ่ง PO ไม่มี) จึงเขียน
 * ตัวแปลงของรายงานนี้แยก แต่ใช้ downloadBlob ตัวเดียวกับทุกจอที่บันทึกไฟล์
 */

/**
 * ค่าที่ขึ้นต้นด้วย = + - @ tab หรือ CR จะถูก Excel ตีความเป็น "สูตร" ตอนเปิดไฟล์
 * ข้อความในรายงานนี้มาจากไฟล์ที่ผู้ใช้อัปโหลด จึงต้องทำให้เป็นข้อความล้วนก่อนเสมอ
 * ไม่งั้นคนที่เปิดรายงานโดนสูตรทำงานใส่ (formula injection ขาออก)
 */
const neutralizeFormula = (value: string): string =>
  /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;

const escapeCell = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return "";

  const text = neutralizeFormula(String(value));
  return `"${text.replace(/"/g, '""')}"`;
};

export const buildUnreadableRowsCsv = (
  rows: PurchaseOrderImportReportRow[],
): string => {
  const header = ["ตำแหน่งในไฟล์", "แถวในไฟล์", "ข้อความในเซลล์", "สาเหตุ"];
  const body = rows.map((row) =>
    [row.location, row.row_no, row.cell_text, row.reason]
      .map(escapeCell)
      .join(","),
  );

  return [header.map(escapeCell).join(","), ...body].join("\r\n");
};

export const downloadUnreadableRowsCsv = (
  rows: PurchaseOrderImportReportRow[],
  fileName: string,
): void => {
  // นำหน้าด้วย BOM เพื่อให้ Excel บน Windows อ่านภาษาไทยเป็น UTF-8 ไม่เพี้ยน
  const blob = new Blob([`﻿${buildUnreadableRowsCsv(rows)}`], {
    type: "text/csv;charset=utf-8;",
  });

  downloadBlob(fileName, blob);
};
